import React from "react";
import OptionalTextInput from "./ValidatedFields/OptionalTextInput";
import ProjectCodeModalPicker from "./Picker/ProjectCodePicker/ProjectCodeModalPicker";

interface Props {
  value: string;
  onChange: (value: string) => void;
  onEnter?: () => void;
  onEsc?: () => void;
  focusOnMount?: boolean;
  canCreateNew: boolean;
}

export const ProjectCodeInput = (props: Props) => {
  if (site.currentEnvironment.projectCode === "displayInput") {
    return <OptionalTextInput
      value={props.value}
      onChange={props.onChange}
      onEnter={props.onEnter}
      onEsc={props.onEsc}
      focusOnMount={props.focusOnMount}
      maxLength={serverReference.constants.show.maxProjectCodeLength}
    />
  }

  if (site.currentEnvironment.projectCode === "displayBusinessCentral") {
    return <ProjectCodeModalPicker
      canCreateNew={props.canCreateNew}
      nonInPageEditing={{
        onChange: props.onChange,
        value: props.value,
        validatorKey: "projectCodePicker",
        required: false,
      }}
    />;
  }

  return null;
}